import { UserMode } from '../enums';

export class CarbonCopyResult {
    public id: number = 0;
    public userId?: number | null = null;
    public userFullName: string = '';
    public userMode?: UserMode = UserMode.CustomerEmployee;
    public email: string = '';
    public isBlindCarbonCopy: boolean = false;
    public ticketId: number = 0;
    public isDeleted: boolean = false;
}
